import React from 'react';
import { motion } from 'framer-motion';
import { useModal } from '../services/ModalService';
import '../styles/pages/Solutions.css';

const Solutions = () => {
  const { openContactModal } = useModal();

  return (
    <div className="solutions-page">
      {/* Hero Section */}
      <section className="solutions-hero">
        <div className="solutions-container">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            style={{ textAlign: "center" }}
          >
            <div className="hero-badge">
              💡 Innovation & Excellence
            </div>

            <h1 className="hero-title"
            dangerouslySetInnerHTML={{ __html: "Advanced <span class=\"gradient-text\">IT Solutions</span><br />for Modern Businesses" }}
            />

            <p className="hero-subtitle">
              Transform your business with innovative technology solutions designed to drive growth, enhance efficiency, and deliver competitive advantages in today's digital landscape.
            </p>

            <div className="hero-buttons">
              <button
                className="btn-primary"
                onClick={() => openContactModal(
                  'IT Solutions Overview',
                  'Solutions Page - Explore Solutions'
                )}
              >
                Explore Solutions
              </button>
              <button
                className="btn-secondary"
                onClick={() => openContactModal(
                  'IT Solutions Consultation',
                  'Solutions Page - Schedule Consultation'
                )}
              >
                Schedule Consultation
              </button>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Services Section */}
      <section className="solutions-section">
        <div className="solutions-container">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <h2 className="solutions-section-title gradient-text">Comprehensive Technology Solutions</h2>
            <p className="solutions-section-subtitle">
              Innovative technology solutions to drive your business forward with cutting-edge development and strategic consulting
            </p>

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
              gap: '30px',
              marginTop: '60px'
            }}>
              <div className="solutions-glass-card">
                <h3 style={{ color: '#8B5CF6', marginBottom: '20px', fontSize: '1.5rem' }}>Software Development</h3>
                <p style={{ marginBottom: '20px', lineHeight: '1.6' }}>Custom software development solutions tailored to your business needs with modern frameworks and best practices.</p>
                <ul style={{ listStyle: "none", padding: 0, color: "#666" }}>
                  <li style={{ marginBottom: "8px" }}>✓ Web & Mobile Applications</li>
                  <li style={{ marginBottom: "8px" }}>✓ API Development & Integration</li>
                  <li style={{ marginBottom: "8px" }}>✓ Legacy System Modernization</li>
                  <li style={{ marginBottom: "8px" }}>✓ Quality Assurance & Testing</li>
                </ul>
              </div>

              <div className="solutions-glass-card">
                <h3 style={{ color: '#8B5CF6', marginBottom: '20px', fontSize: '1.5rem' }}>AI & Machine Learning</h3>
                <p style={{ marginBottom: '20px', lineHeight: '1.6' }}>Advanced AI and ML solutions to automate processes, gain insights, and optimize your business operations.</p>
                <ul style={{ listStyle: "none", padding: 0, color: "#666" }}>
                  <li style={{ marginBottom: "8px" }}>✓ Predictive Analytics</li>
                  <li style={{ marginBottom: "8px" }}>✓ Natural Language Processing</li>
                  <li style={{ marginBottom: "8px" }}>✓ Computer Vision Solutions</li>
                  <li style={{ marginBottom: "8px" }}>✓ Automated Decision Making</li>
                </ul>
              </div>

              <div className="solutions-glass-card">
                <h3 style={{ color: '#8B5CF6', marginBottom: '20px', fontSize: '1.5rem' }}>Cloud Solutions</h3>
                <p style={{ marginBottom: '20px', lineHeight: '1.6' }}>Scalable cloud infrastructure and migration services for modern, resilient, and cost-effective operations.</p>
                <ul style={{ listStyle: "none", padding: 0, color: "#666" }}>
                  <li style={{ marginBottom: "8px" }}>✓ Cloud Migration & Strategy</li>
                  <li style={{ marginBottom: "8px" }}>✓ Multi-Cloud Architecture</li>
                  <li style={{ marginBottom: "8px" }}>✓ Serverless Computing</li>
                  <li style={{ marginBottom: "8px" }}>✓ Cloud Cost Optimization</li>
                </ul>
              </div>

              <div className="solutions-glass-card">
                <h3 style={{ color: '#8B5CF6', marginBottom: '20px', fontSize: '1.5rem' }}>DevOps & SRE</h3>
                <p style={{ marginBottom: '20px', lineHeight: '1.6' }}>DevOps and Site Reliability Engineering for efficient software delivery and reliable infrastructure management.</p>
                <ul style={{ listStyle: "none", padding: 0, color: "#666" }}>
                  <li style={{ marginBottom: "8px" }}>✓ CI/CD Pipeline Implementation</li>
                  <li style={{ marginBottom: "8px" }}>✓ Infrastructure as Code</li>
                  <li style={{ marginBottom: "8px" }}>✓ Monitoring & Observability</li>
                  <li style={{ marginBottom: "8px" }}>✓ Performance Optimization</li>
                </ul>
              </div>

              <div className="solutions-glass-card">
                <h3 style={{ color: '#8B5CF6', marginBottom: '20px', fontSize: '1.5rem' }}>Data Analytics</h3>
                <p style={{ marginBottom: '20px', lineHeight: '1.6' }}>Comprehensive data analytics and business intelligence solutions to unlock insights and drive decisions.</p>
                <ul style={{ listStyle: "none", padding: 0, color: "#666" }}>
                  <li style={{ marginBottom: "8px" }}>✓ Business Intelligence Dashboards</li>
                  <li style={{ marginBottom: "8px" }}>✓ Data Warehousing Solutions</li>
                  <li style={{ marginBottom: "8px" }}>✓ Real-time Analytics</li>
                  <li style={{ marginBottom: "8px" }}>✓ Data Visualization</li>
                </ul>
              </div>

            </div>
          </motion.div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="solutions-section">
        <div className="solutions-container">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            <div className="solutions-cta-card">
              <h3 style={{
                fontSize: "2rem",
                marginBottom: "20px",
                color: "#8B5CF6"
              }}>
                Ready to Transform Your Business?
              </h3>
              <p style={{
                fontSize: "1.1rem",
                marginBottom: "30px",
                color: "#666",
                maxWidth: "600px",
                margin: "0 auto 30px"
              }}>
                Let's discuss how our innovative technology solutions can accelerate your business growth and digital transformation journey.
              </p>
              <div style={{ display: "flex", gap: "20px", justifyContent: "center", flexWrap: "wrap" }}>
                <button
                  className="btn-primary"
                  onClick={() => openContactModal(
                    'Project Discussion',
                    'Solutions Page - Start Your Project'
                  )}
                >
                  Start Your Project
                </button>
                <button
                  className="btn-secondary"
                  onClick={() => openContactModal(
                    'Discovery Call',
                    'Solutions Page - Schedule Discovery Call'
                  )}
                >
                  Schedule Discovery Call
                </button>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Solutions;
